import React from 'react';
import Map from './Map';
import './MapView.css';

function MapView({
  openSearch = false,
  onSearchOpened = null,
  events = null,
  isLoading = false,
  onSwitchToListPanel = null,
  drawerBackdropOpen = false,
  onDrawerBackdropClose = null,
  eventCategory = 'all',
  onDismissEventCategory = null,
  /** Opcjonalnie: element obejmowany przez Fullscreen API (np. rząd mapa + panel Odkryj). */
  fullscreenHostRef = null,
}) {
  return (
    <div className="map-view">
      <Map
        openSearch={openSearch}
        onSearchOpened={onSearchOpened}
        externalEvents={events}
        externalLoading={isLoading}
        onSwitchToListPanel={onSwitchToListPanel}
        drawerBackdropOpen={drawerBackdropOpen}
        onDrawerBackdropClose={onDrawerBackdropClose}
        eventCategory={eventCategory}
        onDismissEventCategory={onDismissEventCategory}
        fullscreenHostRef={fullscreenHostRef}
      />
    </div>
  );
}

export default MapView;






